import {Component} from 'react'
import { Col, Container, Row } from 'reactstrap';
import CustomCard from '../../../components/common/customCard';
import HeadMobile from '../../../components/common/global_layout/carouselMobile';
import NavTab from '../../../components/common/global_layout/navTab2';

class Voyage extends Component {
  constructor(props) {
    super(props);
    this.state = {};
  }
  render() {
    return (
      <>
        <Container>
          <NavTab />
        </Container>
        <Container>
            <br /><br />
            <center><h3>Choisir Votre Circuit:</h3></center>
            <br />
            <Col>
          <div className="custom-card mx-3">
                <Row className="mx-5">
                  <CustomCard
                    IdSpe="hg-ctrl-voy1"
                    size={6}
                    imgPath={"/imgs/cirucuitsChoice/mondialCircuit.png"}
                    linkPath={"/voyages/mondial_circuit"}
                    title={"Circuit dans le Monde"}
                    paddingCost={"0 5px 0 15px"}
                  />
                  <CustomCard
                    IdSpe="hg-ctrl-voy1"
                    size={6}
                    imgPath={"/imgs/cirucuitsChoice/haje.png"}
                    linkPath={"/voyages/haj_omra_circuit"}
                    title={"Circuit Hajj/Omra"}
                    paddingCost={"0 15px 0 5px"}
                  />
                </Row>
              </div>
              </Col>
        <HeadMobile />
        </Container>
      </>
    );
  }
}
 
export default Voyage ;